import { Action, Selector, State, StateContext } from '@ngxs/store';

import { CloseMenu, OpenMenu, OpenNotification, CloseNotification, OpenTimer, CloseTimer, OpenEula, CloseEula } from '../actions/layout.actions';

export interface NotificationDetailsModel {
  state: string;
  message: string;
}

export interface NotificationModel {
  state: string;
  message: string;
  visible: boolean;
}

export interface LayoutStateModel {
  showMenu: boolean;
  showNotification: NotificationModel;
  showTimer: boolean;
  showEula: boolean;
}

@State<LayoutStateModel>({
  name: 'layout',
  defaults: {
    showMenu: false,
    showNotification: {
      state: 'info',
      message: null,
      visible: false,
    },
    showTimer: false,
    showEula: false
  },
})
export class LayoutState {
  @Selector()
  static getShowMenu(state: LayoutStateModel) {
    return state.showMenu;
  }

  @Action(OpenMenu)
  openMenu({ patchState }: StateContext<LayoutStateModel>) {
    patchState({
      showMenu: true,
    });
  }

  @Action(CloseMenu)
  closeMenu({ patchState }: StateContext<LayoutStateModel>) {
    patchState({
      showMenu: false,
    });
  }

  @Selector()
  static getShowNotification(state: LayoutStateModel) {
    return state.showNotification;
  }

  @Action(OpenNotification)
  openNotification({ patchState }: StateContext<LayoutStateModel>, data: NotificationDetailsModel) {
    patchState({
      showNotification:  {
        visible: true,
        ...data
      }
    });
  }

  @Action(CloseNotification)
  closeNotification({ patchState }: StateContext<LayoutStateModel>, data: NotificationDetailsModel) {
    patchState({
      showNotification: {
        visible: false,
        ...data
      }
    });
  }

  @Selector()
  static getShowTimer(state: LayoutStateModel) {
    return state.showTimer;
  }

  @Action(OpenTimer)
  openTimer({ patchState }: StateContext<LayoutStateModel>) {
    patchState({
      showTimer: true,
    });
  }

  @Action(CloseTimer)
  closeTimer({ patchState }: StateContext<LayoutStateModel>) {
    patchState({
      showTimer: false,
    });
  }

  @Selector()
  static getShowEula(state: LayoutStateModel) {
    return state.showEula;
  }

  @Action(OpenEula)
  openEula({ patchState }: StateContext<LayoutStateModel>) {
    patchState({
      showEula: true,
    });
  }

  @Action(CloseEula)
  closeEula({ patchState }: StateContext<LayoutStateModel>) {
    patchState({
      showEula: false,
    });
  }
}
